import { render, staticRenderFns } from "./HtmlPdf.vue?vue&type=template&id=230a5ece&scoped=true"
import script from "./HtmlPdf.vue?vue&type=script&lang=js"
export * from "./HtmlPdf.vue?vue&type=script&lang=js"
import style0 from "./HtmlPdf.vue?vue&type=style&index=0&id=230a5ece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230a5ece",
  null
  
)

export default component.exports